import type { IFlyerSliderResources } from "@/src/sponsored-brand/FlyerSlider.Resources";

export const FlyerSliderResourcesEn: IFlyerSliderResources = {
    noFlyersFound: "Product not found",
};
